import SectionHeader from "../Typography/SectionHeader"
import TableOfContentsWrapper from "./TableOfContents/TableOfContentsWrapper"
import Section from "./TableOfContents/Section"
import SubSection from "./TableOfContents/SubSection"

export const shortcodes = { H1: SectionHeader, TableOfContentsWrapper, Section, SubSection }
